module.exports = __webpack_public_path__ + "img/blank-profile.cac235da.png";